import { createFeatureFlagSelector } from "../../selectors/featureFlag";

export const featureFlagFindAll = (section, featureList) =>
    featureList
        .filter(
            ({ path, value }) =>
                (path === "allContentAreas" || section.startsWith(path)) &&
                value
        )
        .map(({ value }) => value);

/**
 * Get feature flag string value by key, and matching path.
 *
 * @function callback
 * @param state - redux state reference.
 * @return string value found in the state object.
 *
 * @param key - feature flag key reference.
 * @return {callback}
 */

export const getFeatureFlagString = (key) => {
    const selector = createFeatureFlagSelector(key);
    return (state) =>
        selector(state).reduce(
            (acc, obj) =>
                (obj?.path === state?.app?.path &&
                    typeof obj?.value === "string" &&
                    obj?.value) ||
                acc,
            ""
        );
};
